/* eslint-disable react-hooks/exhaustive-deps */
import i18next from 'i18next'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'
import {styled} from 'styled-components'
import {KTSVG} from '../../../../_metronic/helpers'
import {PopoverText} from '../../../../components/Popover/Popover'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  amandementSelector,
  resetFilterAmandement,
  setFilterAmandement,
} from '../../../../redux/slices/amandementSlices'
import Pagination from '../../component/Pagination'
import RowFilter from './RowFilter'
import {BadgeColor} from '../../../../components/BadgeColor'
import {BadgeColorOrder} from '../BadgeColorOrder'

const Wrapper = styled.div`
  position: relative;
`

const TableWrapper = styled.div`
  position: relative;
  z-index: 0;
  margin-top: 1rem;
`

interface Props {
  paginate: any
  numberUrls: any
  isLoading: any
  items: any[]
  popoverProvinceContent: (item: any) => void
  popoverCityContent: (item: any) => void
  onExpandRow: (e: any) => void
  onUpload(id: string): void
  onDetailIconClick: (value: any) => void
  onScheeduleIconClick: (value: any) => void
  onAttachmentIconClick: (value: any) => void
}

export const OrderAmandementTable = (props: Props) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const {filterAmandement} = useAppSelector(amandementSelector)
  const dispatch = useAppDispatch()

  const onReloadTable = () => dispatch(resetFilterAmandement())

  const {RowEmptyData, RowLoader} = useRowTable({colSpan: 12, onReloadTable})

  const handleChangePageSize = (per_page: number) => {
    dispatch(setFilterAmandement({...filterAmandement, per_page}))
  }

  function handleArrayIntoString(data: any) {
    let temp = ''
    data.forEach((item: any, index: any) => {
      if (index + 1 === data.length) temp = temp + item.product_name
      else temp = temp + item.product_name + ', '
    })
    return temp
  }

  useEffect(() => {
    return () => {
      onReloadTable()
    }
  }, [])

  return (
    <Wrapper>
      <SelectPageSize
        initialValue={filterAmandement?.per_page ?? 5}
        onChange={(value: any) => handleChangePageSize(value?.value ?? 5)}
      />

      <TableWrapper>
        <TableUI.TableWrapper>
          <TableUI.Table>
            <TableUI.THead>
              <tr>
                <th>{t('order-aksi')}</th>
                <th>{t('order-no')}</th>
                <th>{t('order-tanggal')}</th>
                <th>{t('order-pelanggan')}</th>
                <th>{t('order-perihal')}</th>
                <th>{t('Sektor')}</th>
                <th>{t('sub-order-provinsi')}</th>
                <th>{t('sub-order-kota')}</th>
                <th>{t('sub-order-produk')}</th>
                <th>{t('Total Kuantum')}</th>
                <th>Total {t('Price')}</th>
                <th>Status</th>
              </tr>
            </TableUI.THead>

            <TableUI.TBody>
              <RowFilter />

              {props.isLoading ? (
                <RowLoader />
              ) : props.items.length === 0 ? (
                <RowEmptyData />
              ) : (
                props.items.map((item: any, _index: any) => (
                  <>
                    <tr className={item.status_text.match('Revisi') ? 'bg-kuning' : ''}>
                      <td>
                        <div
                          className='d-flex py-0 justify-content-center'
                          style={{marginTop: '1px', marginBottom: '1px'}}
                        >
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-3 me-1'
                            title={t('ke_amandemen')}
                            onClick={() => {
                              sessionStorage.setItem('po', item.id)
                              sessionStorage.setItem('amandemen', 'true')
                              navigate('/management/order/amandemen/' + item.id + '/create')
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/file-text-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            title={t('order-lampiran')}
                            onClick={() => props.onUpload(item.id)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/archive-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        </div>
                      </td>
                      <td>
                        <div
                          className='d-flex justify-content-evenly align-items-center py-3'
                          style={{marginTop: '-.5px', marginBottom: '-.8px'}}
                        >
                          <button
                            className='iconArow d-flex justify-content-start align-items-start me-2'
                            data-target={'target' + item['id']}
                            onClick={props.onExpandRow}
                          ></button>
                          <span
                            className='fw-semibold cursor-pointer'
                            style={{color: '#274070'}}
                            onClick={() => {
                              sessionStorage.setItem('po', item.id)
                              sessionStorage.setItem('amandemen', 'true')
                              // navigate('/management/order/amandemen/' + item.id)
                              navigate('/management/order/amandemen/' + item.id + '/create')
                            }}
                          >
                            10{item['po_number']}
                          </span>
                        </div>
                      </td>
                      <td>
                        <p>{item['created_at'].slice(0, 10)}</p>
                      </td>
                      <td>
                        <PopoverText
                          content={
                            item['customer']?.title == null || item.customer?.title == ''
                              ? item['customer']?.name
                              : item['customer']?.title + ' ' + item['customer']?.name
                          }
                          index={_index}
                          className='desc-slicee'
                        />
                      </td>
                      <td>
                        {item['regarding'] === 'PO001' ? (
                          <span className='badge badge-light-success'>{t('penjualan')}</span>
                        ) : (
                          <span className='badge badge-light-primary'>{t('Non-penjualan')}</span>
                        )}
                      </td>
                      <td>
                        <span>{t(item.sector?.name)}</span>
                      </td>
                      <td>
                        {item.sector_id !== 3 ? (
                          <PopoverText
                            content={item.provinces}
                            index={_index}
                            className='spec-sliceee'
                          />
                        ) : (
                          <label className='opacity-0'>-</label>
                        )}
                      </td>
                      <td>
                        {item.sector_id !== 3 ? (
                          <PopoverText
                            content={item.cities}
                            index={_index}
                            className='spec-sliceee'
                          />
                        ) : (
                          <label className='opacity-0'>-</label>
                        )}
                      </td>
                      <td>
                        <PopoverText
                          content={handleArrayIntoString(item.children)}
                          index={_index}
                          className='spec-sliceee'
                        />
                      </td>
                      <td>
                        <p>
                          {i18next.language === 'en'
                            ? item.total_left_quantum.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : item.total_left_quantum.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })}{' '}
                          {item.sector_id === 3 ? 'MT' : 'Ton'}
                        </p>
                      </td>
                      <td>
                        {item.is_formulated_price === true ? (
                          <>
                            <p>{t('Formulated Price')}</p>
                          </>
                        ) : (
                          <>
                            <p>
                              {(item.sector_id !== 3 ? 'Rp' : 'USD') +
                                (i18next.language === 'en'
                                  ? item.total_left_price.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : item.total_left_price.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) +
                                (item.sector_id !== 3 ? '/Ton' : '/MT')}
                            </p>
                          </>
                        )}
                      </td>
                      <td>
                        <BadgeColorOrder
                          status={item.status}
                          text={item.status_text}
                          type='header'
                        />
                      </td>
                    </tr>

                    <tr className='fold' id={'target' + item['id']}>
                      <TableUI.TableDetail colSpan={14}>
                        <TableUI.TableWrapper style={{marginBottom: 0}}>
                          <TableUI.Table>
                            <TableUI.THead>
                              <tr style={{backgroundColor: '#274070'}}>
                                <th>{t('order-aksi')}</th>
                                <th>{t('sub-order-item')}</th>
                                <th>Sales Org</th>
                                <th>{t('sub-order-incoterm')}</th>
                                <th>{t('sub-order-wilayah')}</th>
                                <th>{t('sub-order-jenis')}</th>
                                <th>{t('Product Code')}</th>
                                <th>{t('sub-order-produk')}</th>
                                <th>{t('sub-order-spek')}</th>
                                <th>{t('quantumsisa')}</th>
                                <th>{t('Price')}</th>
                                {item.sector_id === 2 && <th>{t('sub-order-gudang')}</th>}
                                <th>Status</th>
                              </tr>
                            </TableUI.THead>

                            <TableUI.TBody>
                              {item.children?.map((subitem: any, _index: any) => (
                                <tr key={subitem?.id ?? _index}>
                                  <td>
                                    <div className='d-flex justify-content-center align-items-center'>
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title='Detail'
                                        onClick={() => props.onDetailIconClick(subitem)}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/file-text-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>

                                      {item.regarding === 'PO001' ? (
                                        <>
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('Jadwal')}
                                            onClick={() => props.onScheeduleIconClick(subitem)}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/calendar-check-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                        </>
                                      ) : (
                                        ''
                                      )}
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('order-lampiran')}
                                        onClick={() => props.onAttachmentIconClick(subitem)}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/archive-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    </div>
                                  </td>
                                  <td>{_index + 1}</td>
                                  <td>{subitem.produsen?.name}</td>
                                  {subitem.sector?.id === 2 ? (
                                    <>
                                      {subitem.incoterm2 == null ? (
                                        <td>
                                          {subitem.incoterm1?.code}-{subitem.incoterm2_id}
                                        </td>
                                      ) : (
                                        <td>
                                          {subitem.incoterm1?.code}-{subitem.incoterm2?.code}
                                        </td>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {subitem.incoterm2 == null ? (
                                        <td className='text-center td2-freeze'>
                                          {subitem.incoterm1?.code}
                                          {subitem.incoterm2_id == null ||
                                          subitem.incoterm2_id === '0'
                                            ? ''
                                            : '-' + subitem.incoterm2_id}
                                        </td>
                                      ) : (
                                        <td className='text-center td2-freeze'>
                                          {subitem.incoterm1?.code}-{subitem.incoterm2?.code}
                                        </td>
                                      )}
                                    </>
                                  )}
                                  <td>
                                    {subitem['province']?.region_name}
                                    {subitem['city']?.city_name
                                      ? ', ' + subitem['city']?.city_name
                                      : ''}
                                  </td>
                                  <td>{subitem['product_type_desc']}</td>
                                  <td>
                                    {parseInt(subitem.material_number) === 0
                                      ? ''
                                      : subitem.material_number.slice(-7)}
                                  </td>
                                  <td>{subitem['product_name']}</td>
                                  <td>
                                    <PopoverText
                                      content={subitem['product_spec']}
                                      index={_index}
                                      className='spec-slice'
                                    />
                                  </td>
                                  <td>
                                    {i18next.language === 'en'
                                      ? (
                                          parseFloat(subitem.fixed_quantum) -
                                          parseFloat(subitem.so_qty_realized)
                                        )?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : (
                                          parseFloat(subitem.fixed_quantum) -
                                          parseFloat(subitem.so_qty_realized)
                                        )?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {subitem.sector_id === 3 ? 'MT' : 'Ton'}
                                  </td>
                                  <td>
                                    <p>
                                      {(subitem.sector_id !== 3 ? 'Rp' : 'USD') +
                                        (i18next.language === 'en'
                                          ? subitem.fixed_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subitem.fixed_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })) +
                                        (subitem.sector_id !== 3 ? '/Ton' : '/MT')}
                                    </p>
                                  </td>

                                  {subitem.sector_id === 2 && (
                                    <td className='text-center'>{subitem['plant_desc']}</td>
                                  )}
                                  <td>
                                    <BadgeColorOrder
                                      status={subitem.status}
                                      text={subitem.status_text}
                                      type='item'
                                    />
                                  </td>
                                </tr>
                              ))}
                            </TableUI.TBody>
                          </TableUI.Table>
                        </TableUI.TableWrapper>
                      </TableUI.TableDetail>
                    </tr>
                  </>
                ))
              )}
            </TableUI.TBody>
          </TableUI.Table>
        </TableUI.TableWrapper>

        <div className='my-5'>
          <Pagination paginate={props.paginate} test={props.numberUrls} />
        </div>
      </TableWrapper>
    </Wrapper>
  )
}
